import React, { useContext, useEffect } from 'react';
import { Form, Input, Modal } from 'antd';

import EventConfigurationContext from '@totem/components/services/threats/configuration/EventConfigurationContext';
import { EventCategory } from '@totem/components/services/threats/configuration/types';

const EventCategoryEditModal = () => {
  const {
    editingCategory,
    categoryModalOpen,
    onCategoryModalClose,
    onSaveCategory,
  } = useContext(EventConfigurationContext);
  const [form] = Form.useForm<EventCategory>();

  const isNew = !editingCategory?.createdAt;

  useEffect(() => {
    if (categoryModalOpen && editingCategory) {
      form.setFieldsValue(editingCategory);
    } else if (!categoryModalOpen) {
      form.resetFields();
    }
  }, [categoryModalOpen, editingCategory, form]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      onSaveCategory({
        ...editingCategory,
        ...values,
        id: values.id.trim().toLowerCase(),
      });
    });
  };

  return (
    <Modal
      title={isNew ? 'Add Category' : 'Edit Category'}
      open={categoryModalOpen}
      onOk={handleOk}
      onCancel={onCategoryModalClose}
      width={520}
      okText={isNew ? 'Create' : 'Save'}
      destroyOnClose
    >
      <Form form={form} layout="vertical" size="small">
        <Form.Item
          name="id"
          label="ID (lowercase key)"
          rules={[
            { required: true, message: 'Required' },
            {
              pattern: /^[a-z0-9_-]+$/,
              message: 'Lowercase letters, numbers, - and _ only',
            },
          ]}
        >
          <Input placeholder="e.g. health" disabled={!isNew} />
        </Form.Item>

        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Required' }]}
        >
          <Input placeholder="e.g. Server & Endpoint Health" />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EventCategoryEditModal;
